import { LOCAL_FORM_CHANGE,
        LOCAL_FORM_CLEAR,
        LOCAL_LOADING,
        LOCAL_SENT,
        LOCAL_GET_GEO_OPTIONS,
        LOCAL_GET_LOCATION } from '../actions/actionTypes'
import {local} from '../../components/Form/data'

const inicialState = {...local, loading: false, sent: false}

const reducer = (state=inicialState, action) => {
    switch (action.type){
        case LOCAL_FORM_CHANGE:{
            const newState = {...state}
            switch (action.payload.propriety){
                case 'root':{
                    if(action.payload.event.target.name==='about'){
                        const max = 300
                        action.payload.event.target.value.length > max ? 
                        newState[action.payload.doc][action.payload.event.target.name] = action.payload.event.target.value.substring(0, max-1) :
                        newState[action.payload.doc][action.payload.event.target.name] = action.payload.event.target.value
                    }else{
                        newState[action.payload.doc][action.payload.event.target.name] = action.payload.event.target.value
                    }
                    return{
                        ...newState
                    }
                }
                case 'feature':{
                    newState.details.features = newState.details.features.map(item => {
                    let feature = {...item}
                    feature.value = ((feature.name === action.payload.event) ? !feature.value : feature.value)
                    return ({...feature} )
                    })
                    return {
                        ...newState
                    }
                }
                case 'imageAdd':{
                    newState.details.images = newState.details.images.concat(action.payload.event)
                    newState.resume.thumbnail = newState.resume.thumbnail === '' ? 0 : newState.resume.thumbnail
                    return {
                        ...newState
                    }
                }
                case 'imageRemove': {
                    if (newState.details.images[action.payload.event]) {
                        newState.details.images.splice(action.payload.event,1)
                    }
                    return {
                        ...newState
                    }
                }
                default:{
                    newState[action.payload.doc][action.payload.propriety][action.payload.event.target.name] = action.payload.event.target.value
                    return{
                        ...newState
                    }
                }
            }
        }
            case LOCAL_FORM_CLEAR:{
                const newState = {
                    resume:{
                        name: '',
                        address: {
                            street:'',
                            streetNumber: '',
                            aditionalInformation: '',
                            locality: '',
                            city: '',
                            shortState: 'Estado',
                            country: '',
                            postalCode: '',
                            location: {
                                lat:'',
                                lng: ''
                            }
                        },
                            ratingAverage : '',
                            ratingCount : '',
                            thumbnail : '',
                            visibility: false,
                            owner: false,
                            author: ''
                    },
                    details:{
                        focalPerson: '',
                        phoneNumber: '',
                        mobileNumber:'',
                        site: '',
                        email: '',
                        images: [],
                        about:'',
                        features: [{
                            name: 'estacionamento',
                            value: false
                        },{
                            name: 'lanchonete',
                            value: false
                        },{
                            name: 'restaurante',
                            value: false
                        },{
                            name: 'espaço kids',
                            value: false
                        },{
                            name: 'estadia',
                            value: false
                        },{
                            name: 'pesca esportiva',
                            value: false
                        },{
                            name: 'churrasqueira',
                            value: false
                        },{
                            name: 'acessibilidade',
                            value: false
                        },{
                            name: 'espaço para eventos',
                            value: false
                        },{
                            name: 'quiosques',
                            value: false
                        },],
                        price: ''
                    },
                    geoOptions:[],
                    loading: false,
                    sent: false
                }
                return{
                    ...newState
                }}
            case LOCAL_LOADING:{
                const newState = {...state}
                newState.loading = !newState.loading
                return{
                    ...newState
                }}
            case LOCAL_SENT:{
                const newState = {...state}
                newState.sent = true
                return{...newState}
            }
            case LOCAL_GET_GEO_OPTIONS:{
                const newState = {...state}
                newState.geoOptions = action.payload
                return{...newState}
            }
            case LOCAL_GET_LOCATION: {
                const newState = {...state}
                newState.resume.address = action.payload
                return {...newState}
            }
            default:
                return state
    }
}

export default reducer


